import {MenuItem} from '@material-ui/core';
import {SearchResult} from 'Core/ducks/search';
import {changeAnalyticsState} from 'Core/ducks/analytics';
import {useDispatch, useSelector} from 'react-redux';
import React from 'react';
import {ReducerState} from 'rootReducer';
import {RouteComponentProps, withRouter} from 'react-router';
import './SearchResult.sass';

type SearchResultProps = {
  itemProps: any;
  selected: boolean;
  result: SearchResult;
  policyFilter: string;
  onClose: () => any;
} & RouteComponentProps;

const SearchResultComponent = (props: SearchResultProps) => {
  const dispatch = useDispatch();
  const {analytics} = useSelector((state: ReducerState) => state.analytics);
  return (
    <MenuItem
      onClick={() => {
        dispatch(
          changeAnalyticsState({
            page: analytics.page,
            ctaResponse: {eventAction: props.policyFilter},
          })
        );
        props.onClose();
        dispatch(props.result.selectRoute);
      }}
      key={props.itemProps.id}
      selected={props.selected}
      className="search-result"
    >
      <p style={{fontSize: '12px'}}>{props.result.label}</p>
    </MenuItem>
  );
};

export default withRouter(SearchResultComponent);
